export interface IWatrRequestAuditLog {
    id: number,
    requestId: number, 
    userId: number,
    logDate: string,
    logMessage: string,
    logType: number,
    fileLoc: string,
    prevStatus?: number,
    currentStatus?: number,
    originalStatus?: number | null,
    updatedStatus?: number | null,
    originalStatusDescription?: string,
    updatedStatusDescription?: string,
    updatedById: number,
    updatedByAlias: string,
    updatedDate: string,
    logActionType?: number,
    logActionTypeDescription?: string,
    logRequestType?: number | null,
    logRequestTypeDescription?: string | null
}